import React, { useEffect, useState } from 'react';
import { fetchJson } from '@utils/fetchJson'; // your custom fetch
//import LoadMore from '@/components/ui/LoadMore'; // reuse from Comments
import HistoryItem from '@components/histroy/HistroyItem';
import { API_BASE_URL } from '../../config';

const HistoryList = ({ record_id,record_type }) => {
  const [history, setHistory] = useState([]);
  const [pagingInfo, setPagingInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadState, setLoadState] = useState(true);
console.log(record_type);
  const fetchHistory = async (page = 0) => {
    setLoading(true);
    try {
      const res = await fetchJson(`${API_BASE_URL}/history`, {
        method: 'POST',
        body: JSON.stringify({
          type: record_type,
          status: 'active',
          record_id:record_id,
          curpage:page,
        }),
      });

      if (res.data) {
        //setHistory(prev => [...prev, ...res.data]);
        setHistory(prev =>
            page === 0 ? [...res.data] : [...prev, ...res.data]
        );
        setPagingInfo(res.paginginfo);
        setLoadState(res.loadstate);
      }
    } catch (error) {
      console.error('History Load Error:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchHistory(0);
  }, [record_id]);

  const loadMore = () => {
    if (pagingInfo && loadState) {
      fetchHistory(pagingInfo.nextpage);
    }
  };

  return (
    <div className="bg-white p-0">
      <h2 className="text-base font-semibold mb-4">History</h2>
      {history.length === 0 && !loading && (
        <div className="text-center text-gray-500 py-6">No history found</div>
      )}
      {history.map(item => (
        <HistoryItem key={item.history_id} item={item} />
      ))}
      {loadState && (
        <div className="flex justify-center pt-2">
          {/* <LoadMore onClick={loadMore} loading={loading} /> */}
          <button
            onClick={() => loadMore(pagingInfo.nextpage)}
            className="text-sm text-blue-500 mt-4"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};
export default HistoryList;